import { jsx } from "react/jsx-runtime";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import { validateTidalLicense } from "../../base/index.js";
function TrackChanges(props) {
  return /* @__PURE__ */ jsx(
    TrackChangesIcon,
    {
      "data-testid": "TrackChanges",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "TrackChanges",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
TrackChanges.tidalIconMeta = {
  categories: "miscellaneous",
  name: "TrackChanges"
};
validateTidalLicense();
export {
  TrackChanges
};
//# sourceMappingURL=TrackChanges.js.map
